import React, { useMemo } from 'react'
import { FlexView } from '../../components/common'
import { Tooltip, Pie, Cell, PieChart } from 'recharts'
import styled from 'styled-components'
import { BsFillCircleFill } from 'react-icons/bs'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

const InfoCard = styled(FlexView)`
    width: 130px;
    height: 85px;
    margin: 0 9px 9px 0;
    justify-content: center;

    & .infoCardTitle {

    font-family: Noto Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 12px;
    color: #777777;
    margin: 8px

    }

    & .subTitle {

    font-family: Noto Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    
    text-align: justify;
    margin: 0;
    
    
    color: #777777;
            
    }

    & .subTitle {

        font-family: Noto Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        
        text-align: justify;
        margin: 0;
        
        
        color: #777777;
                
    }

    & .value {
        font-family: Noto Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 27px;
        text-align: justify;

        color: #000000;
        margin: 0 0 10px 0;
    }

`

const DonutChartCard = ({ ChartData }) => {

  const { t } = useTranslation()
  const data = ChartData.map(d => d[0])
  data.shift()
  const RADIAN = Math.PI / 180
  const COLORS = ['#46C7A8', '#FF8A7E', '#72AEFF']

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.1
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
      <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize="14">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }

  const totalPieces = useMemo(() => _.sumBy(data, 'value'), [data])
  const formatTooltip = value => `${value} (${((value / totalPieces) * 100).toFixed(2)}%)`

  return (
    <FlexView width="100%" flexDirection="column" alignItems="center" justifyContent="center">
      <PieChart width={200} height={150}>
        <Pie
          data={data}
          cx={90}
          cy={70}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={60}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip formatter={formatTooltip} />
      </PieChart>
      <InfoCard flexDirection='column' justifyContent="flex-start" fontSize="small">
        <FlexView flexDirection="row" alignItems="center" style={{ marginLeft: "10px" }}>
          <BsFillCircleFill color="#46C7A8" />
          <h5 style={{ marginLeft: "5px" }} className="infoCardTitle">{t("DOWNHOLE")}</h5>
        </FlexView>
        <FlexView flexDirection="row" alignItems="center" style={{ marginLeft: "10px" }}>
          <BsFillCircleFill color="#FF8A7E" />
          <h5 style={{ marginLeft: "5px" }} className="infoCardTitle">{t("REJECTED")}</h5>
        </FlexView>
        <FlexView flexDirection="row" alignItems="center" style={{ marginLeft: "10px" }}>
          <BsFillCircleFill color="#72AEFF" />
          <h5 style={{ marginLeft: "5px" }} className="infoCardTitle">{t("RETURNED")}</h5>
        </FlexView>
      </InfoCard>
    </FlexView  >
  )

}

export default DonutChartCard